module.exports = __webpack_public_path__ + "img/youngji.f5fb3a6d.png";